import { render, staticRenderFns } from "./AchievementView.vue?vue&type=template&id=47c21403&scoped=true&"
import script from "./AchievementView.vue?vue&type=script&lang=js&"
export * from "./AchievementView.vue?vue&type=script&lang=js&"
import style0 from "./AchievementView.vue?vue&type=style&index=0&id=47c21403&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c21403",
  null
  
)

export default component.exports